import React, { useState } from 'react';

const Tooltip = ({ text, children }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <span className="tooltip-wrapper">
      <span
        className="tooltip-trigger"
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        onFocus={() => setIsVisible(true)}
        onBlur={() => setIsVisible(false)}
        tabIndex="0"
        role="button"
        aria-label="Help"
      >
        {children || (
          <svg
            className="tooltip-icon"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.5" fill="none"/>
            <text x="8" y="11" textAnchor="middle" fontSize="10" fontWeight="600" fill="currentColor">?</text>
          </svg>
        )}
      </span>
      {isVisible && (
        <span className="tooltip-content" role="tooltip">
          {text}
        </span>
      )}
    </span>
  );
};

export default Tooltip;
